export default {
  path: 'content',
  name: 'cms',
};
